import React, { useState, useEffect } from "react";
import { Formik, Form, Field, FieldArray, FastField, useFormik } from "formik";
import Select from "react-select";
import csc from "country-state-city";

export const UserSetting = () => {
  const initialValues = {
    name: "",
    post_code: "",
    street_name: "",
    door_number: "",
    country: "",
    state: "",
    city: "",
    phone_number: "",
    website: "",
    contact: [],
  };
  const addressFromik = useFormik({
    initialValues: {
      country: null,
      state: null,
      city: null,
    },
    onSubmit: (values) => console.log(JSON.stringify(values.country)),
  });

  const countries = csc.getAllCountries();

  const updatedCountries = countries.map((country) => ({
    label: country.name,
    value: country.isoCode,
    ...country,
  }));
  const updatedStates = (countryId) =>
    csc.getStatesOfCountry(countryId).map((state) => ({
      label: state.name,
      value: state.countryCode,
      ...state,
    }));

  const updatedCities = (countryId) =>
    csc.getCitiesOfCountry(countryId).map((city) => ({
      label: city.name,
      value: city.stateCode,
      // lat: city.latitude,
      // long: city.longitude,
      ...city,
    }));

  const [Country, setCountry] = useState<any>({});
  const [State, setState] = useState<any>({});
  const [City, setCity] = useState<any>({});

  const { values, handleSubmit, setFieldValue, setValues } = addressFromik;
  useEffect(() => {}, [values]);

  const onSubmit = (values, onSubmitProps) => {
    let payload = {
      name: values.name,
      post_code: values.post_code,
      street_name: values.street_name,
      door_number: values.door_number,
      country: Country?.label,
      state: State?.label,
      city: City,
      phone_number: values.phone_number,
      website: values.website,
      contact: values.contact,
    };
    console.log("Customer", payload);
    // getAuthorization()
    //   .post("company/add_customer/", payload)
    //   .then((res) => {
    //     onSubmitProps.setSubmitting(false);
    //     Swal.fire({
    //       position: "top-end",
    //       title: "Customer Added!",
    //       showConfirmButton: false,
    //       timer: 3500,
    //       showClass: {
    //         popup: "animate__animated animate__fadeInRight",
    //       },
    //       hideClass: {
    //         popup: "animate__animated animate__fadeOutRight",
    //       },
    //       width: 300,
    //       color: "#FFFFFF",
    //       background: "#2A91D7",
    //       backdrop: `rgba(0,0,0,0)`,
    //     });
    //     getCustomerTabledata();
    //     Navigate("/dashboard/management/customer-dashboard");
    //   })
    //   .catch((err) => {
    //     console.log("Error", err);
    //     onSubmitProps.setSubmitting(false);
    //   });
  };
  const RemoveTemplateHandler = (remove, index) => {
    remove(index);
  };
  const AddTemplateHandler = (push) => {
    push({
      name: "",
      job_role: "",
      phone_number: "",
      email: "",
    });
  };

  return (
    <div>
      <div className="flex flex-wrap">
        <div className="flex-1 mt-7 ml-3">
          <div className="text-center">
            <img
              className="object-cover w-24 h-24 rounded-full m-auto"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=="
              alt="Avatar"
            />
          </div>
          <div className="text-gray-50 text-sm font-Montserrat mt-4 text-center">
            Add User Photo
          </div>
          <div className="text-gray-50 text-sm font-Montserrat mt-1 text-center">
            Remove Photo
          </div>
        </div>
        <div className="flex-4 ">
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            //   validationSchema={validationSchema}
            //   validateOnMount
          >
            <Form>
              <div className="mt-9 grid space-y-10">
                <div className="flex w-3/4 flex-row justify-between space-x-5">
                  <Field name="name">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="text"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-b-2  relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                }
                              : {
                                  className:
                                    "border-b-2  relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                })}
                            placeholder="First Name:"
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-semibold font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                  <Field name="Last_name">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="text"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-b-2  relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                }
                              : {
                                  className:
                                    "border-b-2  relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                })}
                            placeholder="Last Name: "
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-semibold font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                </div>
                <Field name="street_name">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <>
                        <textarea
                          {...field}
                          type="text"
                          rows={3}
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border bg-white rounded-lg relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border bg-white rounded-lg relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="About: "
                        ></textarea>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat  text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </>
                    );
                  }}
                </Field>
                <div className="flex w-3/4 flex-row justify-between space-x-5">
                  <Field name="door_number">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="text"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-b-2  relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                }
                              : {
                                  className:
                                    "border-b-2  relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                })}
                            placeholder="Address: "
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-semibold font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                  <Field name="post_code">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          <input
                            {...field}
                            type="text"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "border-b-2 relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                }
                              : {
                                  className:
                                    "border-b-2  relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                })}
                            placeholder="Phone: "
                          ></input>
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-semibold font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                </div>
                <div className="flex w-3/4 flex-row justify-between space-x-5">
                  <Field name="country">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          {/* <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Country"
                        ></input> */}
                          <Select
                            {...field}
                            id="country"
                            name="country"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "bg-default relative block w-full  border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                }
                              : {
                                  className:
                                    " bg-default relative block w-full  border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                })}
                            options={updatedCountries}
                            value={values.country}
                            placeholder="Country"
                            onChange={(value) => {
                              // setValues(
                              //   { country: value, state: null, city: null },
                              //   false
                              // );
                              setFieldValue("country", value);
                              setCountry(value);
                              console.log("country value", value);
                            }}
                          />
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-semibold font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                </div>
                <div className="flex w-3/4 flex-row justify-between space-x-5">
                  <Field name="state">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          {/* <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Country"
                        ></input> */}
                          <Select
                            {...field}
                            id="state"
                            name="state"
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    "bg-default relative block w-2/4  border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                }
                              : {
                                  className:
                                    " bg-default relative block w-2/4  border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                })}
                            placeholder="State"
                            options={updatedStates(
                              values.country ? values.country.value : null
                            )}
                            value={values.state}
                            onChange={(value) => {
                              setValues({ state: value, city: null }, false);
                              setState(value);
                            }}
                          />
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-semibold font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                  <Field name="city">
                    {(props) => {
                      const { field, form, meta } = props;
                      return (
                        <>
                          {/* <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2 bg-default relative block w-2/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="City"
                        ></input> */}
                          <Select
                            {...field}
                            {...(meta.touched && meta.error
                              ? {
                                  className:
                                    " bg-default relative block w-2/4  border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                }
                              : {
                                  className:
                                    " bg-default relative block w-2/4  border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                                })}
                            id="city"
                            name="city"
                            placeholder="City"
                            options={updatedCities(
                              values.state ? values.state.value : null
                            )}
                            value={values.city}
                            onChange={(value) => {
                              setFieldValue("city", value);
                              setCity(value);
                            }}
                          />
                          {meta.touched && meta.error ? (
                            <label className="text-xs font-semibold font-Montserrat text-red-500">
                              <span className="ml-1">{meta.error}</span>
                            </label>
                          ) : null}
                        </>
                      );
                    }}
                  </Field>
                </div>
                <Field name="website">
                  {(props) => {
                    const { field, form, meta } = props;
                    return (
                      <>
                        <input
                          {...field}
                          type="text"
                          {...(meta.touched && meta.error
                            ? {
                                className:
                                  "border-b-2  relative block w-3/4 px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                              }
                            : {
                                className:
                                  "border-b-2  relative block w-3/4 px-2 border-gray placeholder-gray-50 foucs: outline-none focus:border-blue-200 transition-colors",
                              })}
                          placeholder="Postcode: "
                        ></input>
                        {meta.touched && meta.error ? (
                          <label className="text-xs font-semibold font-Montserrat text-red-500">
                            <span className="ml-1">{meta.error}</span>
                          </label>
                        ) : null}
                      </>
                    );
                  }}
                </Field>
              </div>
            </Form>
          </Formik>
        </div>
      </div>

      <div className="mt-8">
        <div className="flex flex-wrap">
          <div className="font-Montserrat font-medium pt-4 text-sm text-gray-50">
            Get Notification from us by Mail
          </div>

          <label className="flex items-center cursor-pointer pt-3 ml-16">
            <div className="relative">
              <input type="checkbox" className="sr-only" />
              <div className="tableToggleBackground block bg-cyan-200 w-10 h-6 rounded-full"></div>
              <div className="tableDot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition"></div>
            </div>
          </label>
        </div>
        <div className="flex flex-wrap">
          <div className="font-Montserrat font-medium pt-4 text-sm text-gray-50">
            Get Notification from us by SMS
          </div>
          <label className="flex items-center cursor-pointer pt-3 ml-16">
            <div className="relative">
              <input type="checkbox" className="sr-only" />
              <div className="tableToggleBackground block bg-cyan-200 w-10 h-6 rounded-full"></div>
              <div className="tableDot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition"></div>
            </div>
          </label>
        </div>
        <div className="font-Montserrat font-medium pt-4 w-fit cursor-pointer text-sm text-blue-200">
          Change your Email
        </div>
        <div className="font-Montserrat font-medium pt-4 w-fit cursor-pointer text-sm text-blue-200">
          Change your Password
        </div>
      </div>

      <div className="flex flex-row justify-center space-x-144 my-10">
        <button
          type="button"
          className="text-red-600 font-Montserrat font-medium text-lg"
          // onClick={() =>
          //   Navigate("/dashboard/management/customer-dashboard")
          // }
        >
          Go Back
        </button>
        <button
          type="submit"
          className="text-white bg-green-100 hover:bg-green-200 font-Montserrat font-medium text-lg place-content-center rounded-md py-1 px-16 flex flex-shrink-1 "
        >
          Save Changes
        </button>
      </div>
    </div>
  );
};
